import { IFormBasicInfo } from 'legacy/lut/features/partner360/basicInfo'

export const PARTNER_BASIC_INFO_FORM_KEY = 'PARTNER_BASIC_INFO'

export const LOCATIONS_SEPARATOR = ','

export const partnerBasicInfoFields: Record<keyof IFormBasicInfo, string> = {
  branchesCount: 'branchesCount',
  branchesIsApplicable: 'branchesIsApplicable',
  branchesLocations: 'branchesLocations',

  showroomsCount: 'showroomsCount',
  showroomsIsApplicable: 'showroomsIsApplicable',
  showroomsLocations: 'showroomsLocations',

  warehouseCount: 'warehouseCount',
  warehouseIsApplicable: 'warehouseIsApplicable',
  warehouseLocations: 'warehouseLocations',

  salesCount: 'salesCount',
  serviceCount: 'serviceCount',
  isIMPSServiceDelivery: 'isIMPSServiceDelivery',

  totalSales: 'totalSales',
  hpDedicatedSales: 'hpDedicatedSales',
  employersCount: 'employersCount',

  turnover: 'turnover',
  ppsShare: 'ppsShare',
  demoUnits: 'demoUnits',

  isMPSAuditRequirements: 'isMPSAuditRequirements',
  summary: 'summary',
  achievement: 'achievement',
  exhibits: 'exhibits',

  // Retail
  operationProfit: 'operationProfit',
  operationProfitYoY: 'operationProfitYoY',
  ticker: 'ticker',
  growthStrategy: 'growthStrategy',
  storesTotal: 'storesTotal',
  storesPSHW: 'storesPSHW',
  storesPRHW: 'storesPRHW',
}
